import cx from "classnames";

import { Flex, OverflowText } from "@theorgchartdev/storybook";
import {
  SanitizeFieldValue,
  IsFieldNotConfigured
} from "@/appComponents/Blocks/Cards/RecordInfoCard/utils";
import { appstr } from "@coreapp/utils/appstr";
import { getImagePath } from "@coreapp/utils/getImagePath";

export const RecordDisplayLabel = ({
  name,
  showName = true,
  id,
  showId = true,
  title,
  showTitle = true,
  dept,
  showDept = true,
  photoSrc = getImagePath("/static/images/OC-logo.png"),
  showPhoto = true,
  gap = 0
}) => {
  const upperClass = "oc-record-display-label";
  const placeHolder = appstr("Blank");
  const nameNotConfigured = IsFieldNotConfigured(name, null);
  const idNotConfigured = IsFieldNotConfigured(id, null);
  const titleNotConfigured = IsFieldNotConfigured(title, null);
  const deptNotConfigured = IsFieldNotConfigured(dept, null);
  return (
    <Flex className={upperClass} alignItems="flex-start" gap="12px">
      {photoSrc != null && showPhoto && (
        <Flex flex={"0 0 auto"} width="64px" height="64px">
          <img
            className={cx("responsiveImage", `${upperClass}-photo`)}
            src={photoSrc}
            alt="fireSpot"
          />
        </Flex>
      )}
      <Flex direction="column" justifyContent="center" alignItems="flex-start" gap={gap}>
        <Flex justifyContent="space-between" gap="4px">
          {showName && (
            <OverflowText
              clamp={2}
              size="large"
              dataTestId={`${upperClass}-name`}
              colorModifier={nameNotConfigured ? "faintgrey" : undefined}
              modifier={nameNotConfigured ? "italic" : undefined}
            >
              {SanitizeFieldValue(name, null, placeHolder)}
            </OverflowText>
          )}
          {showId && (
            <Flex flex={"0 0 auto"} alignItems="flex-end">
              <OverflowText
                clamp={1}
                colorModifier={idNotConfigured ? "faintgrey" : "grey"}
                modifier={idNotConfigured ? "italic" : undefined}
                size="xsmall"
                dataTestId={`${upperClass}-id`}
              >
                {SanitizeFieldValue(id, null, placeHolder)}
              </OverflowText>
            </Flex>
          )}
        </Flex>
        {showTitle && (
          <OverflowText
            clamp={2}
            size="small"
            modifier={titleNotConfigured ? "italic" : "bold"}
            colorModifier={titleNotConfigured ? "faintgrey" : undefined}
            dataTestId={`${upperClass}-title`}
          >
            {SanitizeFieldValue(title, null, placeHolder)}
          </OverflowText>
        )}
        {showDept && (
          <OverflowText
            clamp={1}
            size="small"
            colorModifier={deptNotConfigured ? "faintgrey" : "grey"}
            modifier={deptNotConfigured ? "italic" : undefined}
            dataTestId={`${upperClass}-dept`}
          >
            {SanitizeFieldValue(dept, null, placeHolder)}
          </OverflowText>
        )}
      </Flex>
    </Flex>
  );
};
